import { FieldDefinition } from './FieldDefinitions';

const commonFields: FieldDefinition[] = [
  {
    id: `address.label`,
    type: `text`,
    // label: `Address`,
  },
  {
    id: `address.lat`,
    type: `numerical`,
    min: -90,
    max: 90,
    // label: `Latitude`,
  },
  {
    id: `address.lng`,
    type: `numerical`,
    min: -180,
    max: 180,
    // label: `Longitude`,
  },
  {
    id: `address.country`,
    type: `text`,
    // label: `Country`,
  },
  {
    id: `address.state`,
    type: `text`,
    // label: `State`,
  },
  {
    id: `address.county`,
    type: `text`,
    // label: `County`,
  },
  {
    id: `address.city`,
    type: `text`,
    // label: `City`,
  },
  {
    id: `address.street`,
    type: `text`,
    // label: `Street`,
  },
  {
    id: `address.number`,
    type: `text`,
    // label: `House Number`,
  },
  {
    id: `address.postal_code`,
    type: `text`,
    // label: `Postal Code`,
  },
];

export const getAddressFields = () => {
  return commonFields;
};
